/*
 * @Author: your name
 * @Date: 2022-03-30 09:42:56
 * @LastEditTime: 2022-05-05 16:50:17
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \h5\src\mixins\messageUnRead.ts
 */
/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  messageUnRead.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {Component, Vue} from "vue-property-decorator";
import {getUnreadInfoCount} from "@/api/commonConfig";
import {goToMessage} from "@/utils/h5ToApp";
import {Action} from "vuex-class";
import { isTourist, goToLogin } from '@/utils/util'

@Component
class MessageUnReadMixin extends Vue {
    @Action setMessageNo!: (val: number | null) => void;
    messageNo = null

    /**
     * 获取消息未读条数
     */
    getMessageNo() {
        getUnreadInfoCount({}).then((res) => {
            this.messageNo = res.data && res.data.unreadCount
            this.setMessageNo(this.messageNo)
        })
    }

    /**
     * @description: 跳消息管理
     * @param {*}
     * @return {*}
     */
    toMessage () {
        if (isTourist()) {
            goToLogin()
            return false
        }
        goToMessage()
    }
}

export { MessageUnReadMixin }
